// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analyticsContainer_gYinV {
  background-color: var(--color-base050)
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/analytics/Analytics.css"],"names":[],"mappings":"AAAA;EACE;AACF","sourcesContent":[".analyticsContainer {\n  background-color: var(--color-base050)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"analyticsContainer": `analyticsContainer_gYinV`
};
export default ___CSS_LOADER_EXPORT___;
